///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.one_ws_cis = abcsetup.one_ws_cis || {};
abcsetup.one_ws_cis.index = abcsetup.one_ws_cis.index || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.one_ws_cis.index = {
    init: function() {
        abcsetup.setTitle('1WorldSync Subscriptions ');

        // Remove Subscription button clicked
        $(document).on('click', '.btn.delete_item', function (e) {
            var _this = $(this);
            var entity_id = _this.attr('data-entity-id');

            abcsetup.alerts.confirm('Remove Subscription', 'Are you sure you want to remove this subscription?', function (resp) {
                if (resp) {
                    abcsetup.blockUI(true);
                    axios.delete('/api/one_ws_cis/delete?entity_id=' + entity_id).then(response => {
                        window.location.reload();
                    });
                }
            });
        });
    },
}
